import { Biconomy } from "@biconomy/mexa";
import { addresses } from "@my-app/contracts";
import { CHAINS } from "./constants";

export let biconomyInstance;

export const setBiconomy = async () => {
  try {
    biconomyInstance = new Biconomy(window.ethereum, {
      apiKey: "CKjuU72wb.f10a6ec6-2ad6-48a4-8116-d12c709e910b",
      debug: true,
      contractAddresses: [addresses[80001].epochBase],
    });
    console.log("biconomy: ", biconomyInstance);
    await biconomyInstance.init();
  } catch (error) {
    console.log("error: ", error);
  }
};

export const getCurrentChain = (chainId) => {
  const chains = Object.keys(CHAINS).map((chain) => CHAINS[chain]);
  const chain = chains.find((chain) => chain.chainId === chainId);

  return chain;
};

export const switchNetwork = async (chainId) => {
  const chain = getCurrentChain(chainId);

  if (chain.chainId === "0x1" || chain.chainId === 5) {
    await window.ethereum.request({
      method: "wallet_switchEthereumChain",
      params: [
        {
          chainId: "0x" + chain.chainId.toString(16),
        },
      ],
    });
  } else {
    await window.ethereum.request({
      method: "wallet_addEthereumChain",
      params: [
        {
          chainId: "0x" + chain.chainId.toString(16),
          chainName: chain.name,
          nativeCurrency: {
            name: chain.tokenName,
            symbol: chain.symbol,
            decimals: 18,
          },
          rpcUrls: [chain.rpcUrl],
          blockExplorerUrls: [chain.explorer],
        },
      ],
    });
  }
};
